// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/authentication/login-background2.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login {
  width: 111vw;
  height: 100%;
  display: flex;
  flex-direction: row;
  background-color: #F4F7F9;
  font-family: "Inter";
}
.login__company-container {
  width: 62.5%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover; /* Ensure the background image covers the container */
  position: relative; /* Make this the parent for the mask */
  overflow: hidden; /* Prevent the mask from overflowing */
}
.login__company-container-mask {
  position: absolute; /* Position it relative to the company-container */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(25, 22, 32, 0.7); /* Slightly less opacity for the mask */
  z-index: 1; /* Ensure it stays above the background image */
  display: flex;
  flex-direction: column;
  text-align: left;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 15% 15% 20% 10%;
}
.login__company-container-mask__star {
  height: 70px;
  margin-bottom: 2rem;
}
.login__company-container-mask__title {
  color: #FFFFFF;
  font-size: 3.5rem;
  font-weight: bold;
  margin-bottom: 1.5rem;
  max-width: 45%;
}
.login__company-container-mask__subtitle {
  color: #FFFFFF;
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 2rem;
}
.login__form-container {
  width: 37.5%;
  background-color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-form {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 0 15%;
}
.login-form__help {
  width: 100%;
  display: flex;
  flex-direction: row;
  color: #8F8F8F;
  font-size: 1rem;
  justify-content: center;
}
.login-form__click {
  margin: 0 0.25rem;
  color: #7F56DA;
  font-size: 1rem;
  cursor: pointer;
}
.login-form__logo {
  width: 80%;
  margin: 20% 0;
}
.login-form__header {
  width: 100%;
  margin-bottom: 10%;
}
.login-form__titles {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
}
.login-form__title {
  color: #000;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: bold;
}
.login-form__subtitle {
  color: #8F8F8F;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-align: left;
}
.login-form__inputs {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 1.5rem;
}
.login-form__inputs__label {
  font-weight: bold;
  font-size: 0.75rem;
}
.login-form__inputs__input-combo {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  width: 100%;
}
.login-form__inputs__help {
  width: 100%;
  display: flex;
  flex-direction: row;
  color: #8F8F8F;
  font-size: 0.75rem;
  justify-content: flex-end;
}
.login-form__inputs__click {
  margin: 0 0.25rem;
  color: #7F56DA;
  font-size: 0.75rem;
  cursor: pointer;
}
.login-form__inputs__button {
  width: 100%;
  margin-top: 10%;
  background-color: #000;
  border-color: transparent;
  border-radius: 4px;
  padding: 3% 0;
  font-size: 0.75rem;
}
.login-form__inputs__text-input {
  width: 100%;
}
.login-form__inputs__text-input::placeholder {
  font-size: 0.75rem !important;
}

@media screen and (max-width: 1024px) {
  .login {
    flex-direction: column;
  }
  .login__company-container {
    display: none;
  }
  .login__form-container {
    width: 100%;
    min-height: 100vh;
    padding: 2rem 0;
  }
  .login-form {
    max-width: 480px;
    margin: 0 auto;
  }
  .login-form__logo {
    margin: 10% 0;
  }
}
@media screen and (max-width: 480px) {
  .login-form {
    padding: 0 1.25rem;
  }
  .login-form__logo {
    width: 60%;
    margin: 15% 0 10% 0;
  }
  .login-form__title {
    font-size: 1.25rem;
  }
  .login-form__subtitle {
    font-size: 0.7rem;
  }
  .login-form__inputs__button {
    padding: 4% 0;
  }
  .login-form__inputs__label {
    font-size: 0.7rem;
  }
  .login-form__inputs__text-input::placeholder {
    font-size: 0.7rem !important;
  }
  .login-form__help {
    font-size: 0.85rem;
  }
  .login-form__click {
    font-size: 0.85rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/features/authentication/components/login/login.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EAEA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,oBAAA;AAAJ;AAEI;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yDAAA;EACA,sBAAA,EAAA,qDAAA;EACA,kBAAA,EAAA,sCAAA;EACA,gBAAA,EAAA,sCAAA;AAAR;AAGI;EACI,kBAAA,EAAA,kDAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,uCAAA,EAAA,uCAAA;EACA,UAAA,EAAA,+CAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,2BAAA;EACA,uBAAA;EACA,wBAAA;AADR;AAEQ;EACI,YAAA;EACA,mBAAA;AAAZ;AAEQ;EACI,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,qBAAA;EACA,cAAA;AAAZ;AAEQ;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAAZ;AAII;EACI,YAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAFR;;AAMA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAHJ;AAKI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;AAHR;AAKI;EACI,iBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AAHR;AAKI;EACI,UAAA;EACA,aAAA;AAHR;AAKI;EACI,WAAA;EACA,kBAAA;AAHR;AAKI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AAHR;AAKI;EACI,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AAHR;AAKI;EACI,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAHR;AAKI;EACI,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,WAAA;AAHR;AAIQ;EACI,iBAAA;EACA,kBAAA;AAFZ;AAIQ;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,WAAA;AAFZ;AAIQ;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;AAFZ;AAIQ;EACI,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AAFZ;AAIQ;EACI,WAAA;EACA,eAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;AAFZ;AAIQ;EACI,WAAA;AAFZ;AAGY;EACI,6BAAA;AADhB;;AAOA;EACI;IACI,sBAAA;EAJN;EAMM;IACI,aAAA;EAJV;EAOM;IACI,WAAA;IACA,iBAAA;IACA,eAAA;EALV;EASE;IACI,gBAAA;IACA,cAAA;EAPN;EASM;IACI,aAAA;EAPV;AACF;AAWA;EACI;IACI,kBAAA;EATN;EAWM;IACI,UAAA;IACA,mBAAA;EATV;EAYM;IACI,kBAAA;EAVV;EAaM;IACI,iBAAA;EAXV;EAeU;IACI,aAAA;EAbd;EAgBU;IACI,iBAAA;EAdd;EAkBc;IACI,4BAAA;EAhBlB;EAqBM;IACI,kBAAA;EAnBV;EAsBM;IACI,kBAAA;EApBV;AACF","sourcesContent":[".login{\n    width: 111vw;\n    // min-height: 100vh;\n    height: 100%;\n    display: flex;\n    flex-direction: row;\n    background-color: #F4F7F9;\n    font-family: 'Inter';\n\n    &__company-container {\n        width: 62.5%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        background-image: url('../../../../assets/authentication/login-background2.jpg');\n        background-size: cover; /* Ensure the background image covers the container */\n        position: relative; /* Make this the parent for the mask */\n        overflow: hidden; /* Prevent the mask from overflowing */\n    }\n\n    &__company-container-mask {\n        position: absolute; /* Position it relative to the company-container */\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background-color: rgba(25, 22, 32, 0.7); /* Slightly less opacity for the mask */\n        z-index: 1; /* Ensure it stays above the background image */\n        display: flex;\n        flex-direction: column;\n        text-align: left;\n        justify-content: flex-start;\n        align-items: flex-start;\n        padding: 15% 15% 20% 10%;\n        &__star{\n            height: 70px;\n            margin-bottom: 2rem;\n        }\n        &__title {\n            color: #FFFFFF;\n            font-size: 3.5rem;\n            font-weight: bold;\n            margin-bottom: 1.5rem;\n            max-width: 45%;\n        }\n        &__subtitle {\n            color: #FFFFFF;\n            font-size: 1rem;\n            font-weight: 500;\n            margin-bottom: 2rem;\n        }\n    }\n\n    &__form-container{\n        width: 37.5%;\n        background-color: #FFFFFF;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n}\n\n.login-form{\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    padding: 0 15%;\n\n    &__help{\n        width: 100%;\n        display: flex;\n        flex-direction: row;\n        color: #8F8F8F;\n        font-size: 1rem;\n        justify-content: center;\n    }\n    &__click{\n        margin: 0 0.25rem;\n        color: #7F56DA;\n        font-size: 1rem;\n        cursor: pointer;\n    }\n    &__logo{\n        width: 80%;\n        margin: 20% 0; \n    }\n    &__header{\n        width: 100%;\n        margin-bottom: 10%;\n    }\n    &__titles{\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 1rem;\n    }\n    &__title{\n        color: #000;\n        font-size: 1.5rem;\n        font-style:normal;\n        font-weight: bold;\n    }\n    &__subtitle{\n        color: #8F8F8F;\n        font-size: 0.75rem;\n        font-style: normal;\n        font-weight: 500;\n        line-height: normal;\n        text-align: left;\n    }\n    &__inputs{\n        display: flex;\n        flex-direction: column;\n        align-items: flex-end;\n        gap: 1.5rem;\n        &__label{\n            font-weight: bold;\n            font-size: 0.75rem;\n        }\n        &__input-combo{\n            display: flex;\n            flex-direction: column;\n            align-items: flex-start;\n            gap: 0.5rem;\n            width: 100%;\n        }\n        &__help{\n            width: 100%;\n            display: flex;\n            flex-direction: row;\n            color: #8F8F8F;\n            font-size: 0.75rem;\n            justify-content: flex-end;\n        }\n        &__click{\n            margin: 0 0.25rem;\n            color: #7F56DA;\n            font-size: 0.75rem;\n            cursor: pointer;\n        }\n        &__button{\n            width: 100%;\n            margin-top: 10%;\n            background-color: #000;\n            border-color: transparent;\n            border-radius: 4px;\n            padding: 3% 0;\n            font-size: 0.75rem;\n        }\n        &__text-input{\n            width: 100%;\n            &::placeholder{\n                font-size: 0.75rem !important;\n            }\n        }\n    }\n}\n\n@media screen and (max-width: 1024px) { // Tablet breakpoint\n    .login {\n        flex-direction: column;\n        \n        &__company-container {\n            display: none; // Hide the image container on tablet and below\n        }\n        \n        &__form-container {\n            width: 100%;\n            min-height: 100vh;\n            padding: 2rem 0;\n        }\n    }\n\n    .login-form {\n        max-width: 480px;\n        margin: 0 auto;\n        \n        &__logo {\n            margin: 10% 0; // Reduce top margin since we don't have the image\n        }\n    }\n}\n\n@media screen and (max-width: 480px) { // Mobile breakpoint\n    .login-form {\n        padding: 0 1.25rem; // Smaller padding on mobile\n        \n        &__logo {\n            width: 60%; // Slightly smaller logo\n            margin: 15% 0 10% 0;\n        }\n        \n        &__title {\n            font-size: 1.25rem; // Smaller title\n        }\n        \n        &__subtitle {\n            font-size: 0.7rem; // Smaller subtitle\n        }\n        \n        &__inputs {\n            &__button {\n                padding: 4% 0; // Slightly larger touch target\n            }\n            \n            &__label {\n                font-size: 0.7rem;\n            }\n            \n            &__text-input {\n                &::placeholder {\n                    font-size: 0.7rem !important;\n                }\n            }\n        }\n        \n        &__help {\n            font-size: 0.85rem;\n        }\n        \n        &__click {\n            font-size: 0.85rem;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
